/**
 * Logic for the correct value of "main_modules2" and "fire_basic_coverage" fields
 * which depends on fields "basic_coverage_postcode_validation_contents"
 * and "basic_coverage_postcode_validation_building" from quote responce.
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    const state = kasko.getState().input;

    if (
      state.fire_basic_coverage_quote_settings === undefined &&
      state.main_modules2_quote_settings === undefined
    ) {
      return;
    }

    if (
      current.fire_basic_coverage_quote_settings !== previous.fire_basic_coverage_quote_settings
    ) {
      if (current.fire_basic_coverage_quote_settings === true) {
        kasko.dispatchEvent('set-state-input', {
          fire_basic_coverage: true,
        });
        kasko.dispatchEvent('set-form-input', {
          fire_basic_coverage: true,
        });
        kasko.dispatchEvent('trigger-requests');
      } else if (current.fire_basic_coverage_quote_settings === false) {
        kasko.dispatchEvent('set-state-input', {
          fire_basic_coverage: false,
        });
        kasko.dispatchEvent('set-form-input', {
          fire_basic_coverage: false,
        });
        kasko.dispatchEvent('trigger-requests');
      }
    }

    if (current.main_modules2_quote_settings !== previous.main_modules2_quote_settings) {
      if (current.main_modules2_quote_settings === true) {
        kasko.dispatchEvent('set-state-input', {
          main_modules2: true,
        });
        kasko.dispatchEvent('set-form-input', {
          main_modules2: true,
        });
        kasko.dispatchEvent('trigger-requests');
      } else if (current.main_modules2_quote_settings === false) {
        kasko.dispatchEvent('set-state-input', {
          main_modules2: false,
        });
        kasko.dispatchEvent('set-form-input', {
          main_modules2: false,
        });
        kasko.dispatchEvent('trigger-requests');
      }
    }
  });
};
